// extracted by mini-css-extract-plugin
export var active = "_do-2";
export var recordingDot = "_do-1";
export var recordingIndicator = "_do-0";